import { WixThemeVariableNames } from '@wix/wix-site-theme-variables';
const CSS_VARIABLE_REGEX = /var\((?:[^()]+|\((?:[^()]+|\([^()]*\))*\))*\)/g;
export const isCssVariable = value => CSS_VARIABLE_REGEX.test(value);
export const applyThemeVariables = (cssValue, themeVariables) => {
  const extractVariableName = value => {
    var _value$match;
    return (_value$match = value.match(/var\(--\s*([^,\s)]+)/)) == null ? void 0 : _value$match[1];
  };
  const getThemeToken = variableName => {
    return themeVariables[variableName] && variableName in WixThemeVariableNames ? themeVariables[variableName] : undefined;
  };
  return cssValue.replace(CSS_VARIABLE_REGEX, match => {
    const variableName = extractVariableName(match);
    if (typeof variableName !== 'undefined') {
      const themeToken = getThemeToken(variableName);
      return themeToken ? themeToken : match;
    }
    return match;
  });
};
//# sourceMappingURL=apply-theme-variables.js.map